import { ManagerRole } from '../../../../hooks/auth/usePermissions';

export default {
  [ManagerRole.SuperAdmin]: 'Super admin',
  [ManagerRole.Admin]: 'Admin',
  [ManagerRole.SalesManager]: 'Manager vânzări',
  [ManagerRole.SalesLeadership]: 'Conducere vânzări',
  [ManagerRole.ContentManager]: 'Manager conținut',
  [ManagerRole.OnboardingManager]: 'Manager onboarding',
  [ManagerRole.OccAgent]: 'Agent call-center',
};
